import React from "react";
import Hint from "./Hint";

interface Props {
  label: string;
  children: React.ReactElement;
  direction?: "row" | "column" | "label-stacked";
  hint?: string;
}

export default function FormGroup({ label, hint, children, direction }: Props) {
  if (direction === "column") {
    return (
      <div className="form-group flex mb-4 flex-col gap-2">
        {label && <div className="font-normal">{label}</div>}
        {hint && <Hint>{hint}</Hint>}
        {children}
      </div>
    );
  }

  if (direction === "label-stacked") {
    return (
      <div className="form-group flex mb-4 items-start gap-4">
        <div className="flex flex-col gap-1 w-1/2">
          {label && <div className="font-normal">{label}</div>}
          {hint && <Hint>{hint}</Hint>}
        </div>
        <span className="w-1/2">{children}</span>
      </div>
    );
  }

  return (
    <div className="form-group flex mb-4 items-center gap-4">
      <div className="flex gap-2 w-1/3">
        {label && <div className="font-normal">{label}</div>}
        {hint && <Hint>{hint}</Hint>}
      </div>
      <span className="w-2/3">{children}</span>
    </div>
  );
}
